module.exports = __webpack_public_path__ + "img/img2.3f83a8ca.jpg";